import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MlpPlatformPage } from "@/components/site/MlpPlatformPage";
import { MLP_PLATFORM_META_DESCRIPTION } from "@/content/meta/MlpPlatformPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/media-monitoring/platform")({
  head: () => ({
    meta: [
      { title: "Media Monitoring Platform & Media Listening Platform | Perceptica" },
      { name: "description", content: MLP_PLATFORM_META_DESCRIPTION },
      { property: "og:title", content: "Media Monitoring Platform & Media Listening Platform | Perceptica" },
      { property: "og:description", content: MLP_PLATFORM_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Monitoring Platform & Media Listening Platform | Perceptica" },
      { name: "twitter:description", content: MLP_PLATFORM_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/media-monitoring/platform" },
      ...ogImageMeta("en", "/media-monitoring/platform"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-monitoring/platform", service: { name: "Media monitoring platform", description: "Perceptica media monitoring platform for Southeast Europe.", serviceType: "Media monitoring platform" }, software: true }),
  }),
  component: MlpPlatformPage,
});
